// First pass for the Link is extremely simple. In the future we can
// customize the Link to use callbacks and alternate components.
import { Link, LinkProps } from '@mui/material';
import React from 'react';

type HelixLinkProps = {
  href: string;
  variant?: LinkProps['variant'];
  fontWeight?: 'bold';
};

const HelixLink: React.FC<HelixLinkProps> = ({ href, variant, fontWeight, children }) => {
  const wrappedChildren = fontWeight === 'bold' ? <b>{children}</b> : children;

  return (
    <Link href={href} variant={variant}>
      {wrappedChildren}
    </Link>
  );
};

export { HelixLink as default, HelixLink };
export type { HelixLinkProps };
